import heatMapIcon from "./heatMapIcon.svg";
import heatMapActiveIcon from "./heatMapActiveIcon.svg";
import heatMapList from "./heatMapList.svg";
import heatMap1 from "./heatMap1.svg";
import heatMap2 from "./heatMap2.svg";
import heatMap3 from "./heatMap3.svg";
import heatMap4 from "./heatMap4.svg";
import heatMap5 from "./heatMap5.svg";
import heatMap6 from "./heatMap6.svg";
import heatMap7 from "./heatMap7.svg";
import heatMap8 from "./heatMap8.svg";
import heatMap9 from "./heatMap9.svg";
import heatMap10 from "./heatMap10.svg";
import heatMap11 from "./heatMap11.svg";
import heatMap12 from "./heatMap12.svg";
import heatMap13 from "./heatMap13.svg";

import restaurentsOrangeIcon from "./restaurentsOrangeIcon.png";
import restaurentsBlueIcon from "./restaurentsBlueIcon.png";
import restaurentsEventIcon from "./restaurentsEventIcon.png";
import restaurentsIncidentIcon from "./restaurentsIncidentIcon.png";
import restRoomsAlertIcon from "./restRoomsAlertIcon.png";
import restRoomsEventIcon from "./restRoomsEventIcon.png";
import restRoomsIncidentIcon from "./restRoomsIncidentIcon.png";
import entranceAlertIcon from "./entranceAlertIcon.png";
import entranceEventIcon from "./entranceEventIcon.png";
import entranceIncidentIcon from "./entranceIncidentIcon.png";
import loungeEventIcon from "./loungeEventIcon.png";
import loungeIncidentIcon from "./loungeIncidentIcon.png";
import loungeAlertIcon from "./loungeAlertIcon.png";
import machineEventIcon from "./machineEventIcon.png";
import machineIncidentIcon from "./machineIncidentIcon.png";
import machineAlertIcon from "./machineAlertIcon.png";
import restaurentsAlertIcon from "./restaurentsAlertIcon.png";

export default {
  heatMapIcon,
  heatMapActiveIcon,
  heatMapList,
  heatMap1,
  heatMap2,
  heatMap3,
  heatMap4,
  heatMap5,
  heatMap6,
  heatMap7,
  heatMap8,
  heatMap9,
  heatMap10,
  restaurentsOrangeIcon,
  restaurentsBlueIcon,
  restRoomsAlertIcon,
  restRoomsEventIcon,
  restRoomsIncidentIcon,
  entranceAlertIcon,
  entranceEventIcon,
  entranceIncidentIcon,
  heatMap11,
  heatMap12,
  heatMap13,
  restaurentsEventIcon,
  restaurentsIncidentIcon,
  loungeEventIcon,
  loungeIncidentIcon,
  loungeAlertIcon,
  machineEventIcon,
  machineIncidentIcon,
  machineAlertIcon,
  restaurentsAlertIcon,
};
